const img = path => `/img/${path}`;
const icons = path => img(`icons/${path}`);

export default {
  appLogo: img("logo.svg"),
  about: img("about-img.jpg"),
  googleScreenshot: img("google-play-screen.png"),
  pageNotFound: img("404-img.svg"),
  dataNotAvailable: img("data-not-available.svg"),
  governmentLogo: img("government-logo.svg"),
  icons: {
    search: icons("search.svg"),
    sprite: icons("sprite.svg"),
    loader: icons("loader.svg"),
    arrowUp: icons("arrow-up.svg"),
    arrowDown: icons("arrow-down.svg"),
    googleBadge: icons("google-play-badge.png"),
    progress: icons("ic_progress.svg"),
    message: icons("ic_message.svg"),
    help: icons("help-icon.svg")
  }
};



// WEBPACK FOOTER //
// ./src/config/images.js